export enum LogTypeEnum {
  'ALL', 'DEBUG', 'INFO', 'WARN', 'ERROR', 'FATAL', 'OFF'
}
